module.exports = __webpack_public_path__ + "img/button_abriefhistory-Text.ef2eb9c0.svg";